export default __webpack_public_path__ + "img/8382c54280a279ca5d6adad8b880c42f.svg";